import { useDispatch } from "react-redux";
import { useLocalStorage } from "usehooks-ts";
import { ENUM_CHAT_MODE, ENUM_LOCALSTORAGE } from "../components/common/enums";
import usePaidAction from "./usePaidAction";
import { API_CHAT } from "../api/chat";
import { ENUM_STATUS_WINDOW, setTips, setTipsMenu } from "../store/chatSlice";
import { errorToast, successToast } from "../components/mui/Toaster";
import JanusState from "../controls/janus/site/JanusState";
import useNickname from "./site/useNickname";
import { useAppSelector } from "../store/index.ts";
import { useTranslation } from "react-i18next";

export default function useTips() {
  const dispatch = useDispatch();
  const { onTipsMessageClick, onPaidActionClick } = usePaidAction();
  const { name } = useNickname();
  const { t } = useTranslation();

  const tips = useAppSelector((state) => state.chat.tips);
  const tipsMenu = useAppSelector((state) => state.chat.tipsMenu);
  const statusWindow = useAppSelector((state) => state.chat.statusWindow);
  const participantMode = useAppSelector((state) => state.chat.participantMode);

  const defaultTips = { amount: tips?.[0]?.value, ...tips[0] } || { amount: 50 };

  const [currentToken, setCurrentToken] = useLocalStorage(
    ENUM_LOCALSTORAGE.lastAmount,
    defaultTips
  );

  const amount = currentToken.amount;

  const getTips = async (chatId) => {
    await API_CHAT.getTips(chatId)
      .then((e) => {
        const tips = e.data.tips?.global || [];
        const tipsMenu = e.data.tips?.user || [];
        dispatch(setTips(tips));
        dispatch(setTipsMenu(tipsMenu));
        if (!currentToken.amount) setCurrentToken({ amount: tips[0].value, ...tips[0] });
      })
      .catch(errorToast);
  };

  const onTipsAction = (cb) => {
    if (statusWindow !== ENUM_STATUS_WINDOW.stream) {
      errorToast(t("The model is in mode, you cannot send a tip yet.", { mode: statusWindow }));
      return;
    }
    if (participantMode === ENUM_CHAT_MODE.view) {
      errorToast(t("The model is in View mode, you cannot send a tip yet."));
      return;
    }

    return cb();
  };

  // sendTips - отправка чаевых модели
  const postTips = (info) => {
    const cb = async () => {
      const chatId = JanusState.clientChat.chatId;

      try {
        const e = await API_CHAT.postTips(chatId, { nickname: name, ...info });

        successToast(e.data.message);
      } catch (error) {
        return errorToast(error);
      }
    };

    return onPaidActionClick(info?.amount, () => onTipsAction(cb));
  };

  // postLovenseTips - отправка чаевых модели из lovense
  const postLovenseTips = (infoProps) =>
    onTipsMessageClick(async () => {
      const chatId = JanusState.clientChat.chatId;
      const info = { ...infoProps, amount: +infoProps.amount };

      try {
        const res = await API_CHAT.postTips(chatId, info);
        successToast(res.data.message);
      } catch (err) {
        return errorToast(err);
      }
    });

  // отпавка сообщений действий в чаевых
  const onActionsTips = (value, id) => {
    const tipProps = { amount: +value, id };
    return onTipsAction(() => onTipsMessageClick(() => postTips(tipProps)));
  };

  // отправка из локалсторадж
  const postSimpleTips = () => postTips(currentToken);

  return {
    currentToken,
    tips,
    amount,
    tipsMenu,
    setCurrentToken,
    postLovenseTips,
    postTips,
    onTipsMessageClick,
    getTips,
    onActionsTips,
    postSimpleTips,
  };
}
